import { Component } from 'react';

import { auth } from '../base';

export default class Auth extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      authChecked: false
    };
  }

  componentWillMount() {
    auth.onAuthStateChanged(user => {
      this.setState({
        authChecked: true
      });
    });
  }

  render() {
    return this.state.authChecked ? this.props.children : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth.js